import IconButton from '@mui/material/IconButton'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import clsx from 'clsx'
import { Button } from 'components/Button/Button'
import { StyledDropdown } from 'components/Dropdown/StyledDropdown'
import { ReactComponent as ThreeDotsSvg } from 'images/icons/three_dots.svg'
import { useState } from 'react'

import style from './ActionsMenu.module.css'

type ActionsMenuItemProps = {
  onClick?: React.MouseEventHandler<HTMLLIElement>
  disabled?: boolean
  title?: string
}

export function ActionsMenuItem(props: React.PropsWithChildren<ActionsMenuItemProps>) {
  // Native title on MUI disabled MenuItem never shows (pointer-events: none).
  // Wrap in Tooltip + span so blocked actions still explain why.
  const item = (
    <MenuItem
      className={props.disabled ? clsx(style.menuItem, style.menuItemDisabled) : style.menuItem}
      disabled={props.disabled}
      title={props.disabled ? undefined : props.title}
      sx={{
        pl: 0,
        height: 40,
      }}
      onClick={props.onClick}
    >
      {props.children}
    </MenuItem>
  )

  if (props.disabled && props.title) {
    return (
      <Tooltip title={props.title} placement="left" enterDelay={300}>
        <span className={style.menuItemTooltipWrap}>{item}</span>
      </Tooltip>
    )
  }

  return item
}

function ActionsMenu(props: any) {
  const [anchorEl, setAnchorEl] = useState(null)
  const showActionsMenu = Boolean(anchorEl)

  const onShowActionsClicked = (e: any) => {
    e.stopPropagation()
    setAnchorEl(e.currentTarget)
  }

  const onCloseActions = (e: any) => {
    e.stopPropagation()
    setAnchorEl(null)
  }

  const onItemClick = (e: any) => {
    e.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton className={style.btnShowActions} onClick={onShowActionsClicked} data-test-id={'button-more-action'}>
        <ThreeDotsSvg />
      </IconButton>
      <StyledDropdown
        className={style.menu}
        classes={{ list: style.menuList }}
        anchorEl={anchorEl}
        open={showActionsMenu}
        onClose={onCloseActions}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        MenuListProps={{ sx: { pt: 0.5 } }}
        onClick={onItemClick}
      >
        {props.children}
      </StyledDropdown>
    </>
  )
}

export default ActionsMenu
